import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getMomentLocale } from '@helpers/locale';

const VersionPreview = ({ versionCard }) => {
  const { filename, small_thumbnail } = versionCard.version_details;
  const timestamp = moment(versionCard.created_at).locale(getMomentLocale()).format('LL');

  return (
    <div className="card version-card">
      <div className="header__image">
        <img src={small_thumbnail} alt="thumbnail" />
      </div>
      <div className="header__info">
        <p className="filename">{filename}</p>
        <p className="created-at">{`${t('Created')} ${timestamp}`}</p>
      </div>
    </div>
  );
};

VersionPreview.propTypes = {
  versionCard: PropTypes.shape({
    created_at: PropTypes.string,
    id: PropTypes.string,
    version_details: PropTypes.shape({
      filename: PropTypes.string,
      small_thumbnail: PropTypes.string,
    })
  }).isRequired,
};

export default VersionPreview;
